import type { DashboardCardConfig, DashboardCardFormatFields } from '../types'
import type { GenericWidgetConfig, SearchCardTypes } from '@edge/spark/io-dashboards'

export const convertDashboardCardFormatFieldsToGenericWidgetConfig = (
    format: Partial<DashboardCardFormatFields>,
    aql: string,
    searchCardType: SearchCardTypes = 'SEARCH',
    workflows?: DashboardCardConfig['workflows'],
): GenericWidgetConfig => {
    if (!format) {
        return {}
    }

    const workflowsAsNumberArray = workflows?.map((wf, idx) => (wf ? idx + 1 : 0)).filter((wf) => wf)

    const updatedConfig: GenericWidgetConfig = {
        title: format.cardTitle,
        label: format.mainLabel,
        label2: format.mainLabel2,
        sublabel: format.mainSubLabel,
        linklabel: format.cardActionLabel,
        linkurl: format.cardActionUrl,
        workflows: workflowsAsNumberArray,
    }

    if (searchCardType === 'SEARCH' || searchCardType === 'STATIC') {
        updatedConfig.search = {
            searchString: aql,
            primary: {
                dataField: format.primaryDataField || 'none',
                rightLabel: '',
            },
            searchDetailView: format.searchDetailView,
            searchDetailTitle: format.searchDetailTitle,
        }

        if (format.firstPositionDataField !== 'none') {
            updatedConfig.search.lowerLeft = {
                dataField: format.firstPositionDataField || 'none',
                leftLabel: '',
                rightLabel: '',
            }
        }

        if (format.secondPositionDataField !== 'none') {
            updatedConfig.search.lowerRight = {
                dataField: format.secondPositionDataField || 'none',
                leftLabel: '',
                rightLabel: '',
            }
        }
    }

    if (searchCardType === 'CONTACT_LOG') {
        updatedConfig.contactLogSearch = {
            searchString: aql,
            primary: {
                dataField: format.primaryDataField || 'none',
                rightLabel: '',
            },
            searchDetailView: format.searchDetailView,
            searchDetailTitle: format.searchDetailTitle,
        }

        if (format.firstPositionDataField !== 'none') {
            updatedConfig.contactLogSearch.lowerLeft = {
                dataField: format.firstPositionDataField || 'none',
                leftLabel: '',
                rightLabel: '',
            }
        }

        if (format.secondPositionDataField !== 'none') {
            updatedConfig.contactLogSearch.lowerRight = {
                dataField: format.secondPositionDataField || 'none',
                leftLabel: '',
                rightLabel: '',
            }
        }
    }

    return updatedConfig
}

export default convertDashboardCardFormatFieldsToGenericWidgetConfig
